
import { DossierConfigService } from "@/services/dossier-config-service";
import { SaleLayoutPaymentColSettings } from "@/utils/sale-layouts/payment-col";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
import AppPaymentColSettings from "./PaymentColSettings.vue";
import AppSelectFreeLinePlacement from "./SelectFreeLinePlacement.vue";

export default Vue.extend({
	data() {
		return {
			toEditCol: null as null | SaleLayoutPaymentColSettings,
			selectedLanguage: DossierConfigService.getLanguages().LanguageNames[0],
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
	},
	methods: {
		edit(col: SaleLayoutPaymentColSettings) {
			this.toEditCol = col;
		},
		addColumn() {
			this.toEditCol = new SaleLayoutPaymentColSettings();
			this.layout.Payments.Cols.push(this.toEditCol);
		},
		async removeColumn(i: number) {
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("are-you-sure-you-want-to-remove-this-column")).setClass("warning").show();
			if (!confirm) {
				return;
			}
			this.layout.Payments.Cols.splice(i, 1);
		},
	},
	components: {
		AppPaymentColSettings,
		AppSelectFreeLinePlacement
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
